import LeadEventHistory from 'components/lead-event-history'

const History = ({ contactId }) => <LeadEventHistory params={{ contactId }} />

export default History
